import { render, staticRenderFns } from "./TimelineOneSide.vue?vue&type=template&id=2cfa5e5a&lang=pug&"
import script from "./TimelineOneSide.vue?vue&type=script&lang=js&"
export * from "./TimelineOneSide.vue?vue&type=script&lang=js&"
import style0 from "./TimelineOneSide.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VMain } from 'vuetify/lib/components/VMain';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VApp,VCard,VCardText,VCardTitle,VFooter,VMain,VTimeline,VTimelineItem})
